// First Layer of Claims Module of Mutation
import clone from 'clone'
import { initialState } from '../index'
import {
  CLAIMS_INIT_LOADING,
  CLAIMS_INIT_SUCCESS,
  CLAIMS_INIT_FAIL,
  CLAIMS_CLAIMDETAIL_RESET,
  CLAIMS_REGISTER_INIT_LOADING,
  CLAIMS_REGISTER_INIT_SUCCESS,
  CLAIMS_REGISTER_INIT_FAIL,
  CLAIMS_LIFECYCLE,
  INIT_CLAIM_POLICY,
  CLAIMS_LISTING_INIT_LOADING,
  CLAIMS_LISTING_INIT_SUCCESS,
  CLAIMS_LISTING_INIT_FAIL,
  CLAIMS_CLAIMDETAIL_EDITSTATUS,
  CLAIMS_PARAMS_SUCCESS,
  CLAIMS_PARAMS_FAIL,
  CLAIMS_PARAMS_RESERVES_SUCCESS,
  CLAIMS_PARAMS_RESERVES_FAIL,
  CLM_REN_MSG_INIT_LOADING,
  CLM_REN_MSG_INIT_SUCCESS,
  CLM_REN_MSG_INIT_FAIL,
  CLAIMS_HASRIORRESADJ,
  CLAIMS_HASRIORRESADJ_LOADING
} from '@/store/types'

export const general = {
  [CLAIMS_INIT_LOADING](state) {
    state.init = 0
    state.initErr = []
    state.menu = {}
  },
  [CLAIMS_INIT_SUCCESS](state, data) {
    state.init = 1
    state.initErr = []
    state.menu = data.menu
  },
  [CLAIMS_INIT_FAIL](state, error) {
    state.init = 2
    state.initErr = error
    state.menu = {}
  },
  [CLAIMS_REGISTER_INIT_LOADING](state) {
    state.claimRegister.init = 0
    state.claimRegister.initErr = []
    state.claimRegister.menu = {}
  },
  [CLAIMS_REGISTER_INIT_SUCCESS](state, data) {
    state.claimRegister.init = 1
    state.claimRegister.initErr = []
    state.claimRegister.menu = data.menu
  },
  [CLAIMS_REGISTER_INIT_FAIL](state, error) {
    state.claimRegister.init = 2
    state.claimRegister.initErr = error
    state.claimRegister.menu = {}
  },
  [CLAIMS_LIFECYCLE](state, data) {
    state.claimDetail.claimLifeCycle = data
  },
  [INIT_CLAIM_POLICY](state, data) {
    commitInitClaim(state, data)
  },
  [CLAIMS_LISTING_INIT_LOADING](state) {
    state.claimListing.init = 0
    state.claimListing.initErr = []
    state.claimListing.menu = {}
  },
  [CLAIMS_LISTING_INIT_SUCCESS](state, data) {
    state.claimListing.init = 1
    state.claimListing.initErr = []
    state.claimListing.menu = data.menu
    state.claimListing.busClsList = data.dataMap.busClsList
    state.claimListing.clmStatList = data.dataMap.clmStatList
    state.claimListing.interList = data.dataMap.interList
    state.claimListing.nol1List = data.dataMap.nol1List
  },
  [CLAIMS_LISTING_INIT_FAIL](state, error) {
    state.claimListing.init = 2
    state.claimListing.initErr = error
    state.claimListing.menu = {}
  },
  [CLAIMS_CLAIMDETAIL_RESET](state) {
    state.claimDetail = clone(initialState.claimDetail)
  },
  [CLAIMS_CLAIMDETAIL_EDITSTATUS](state, data) {
    state.claimDetail.commonInfo.clmStat = data.clmStat
    state.claimDetail.commonInfo.cseStat = data.cseStat
  },
  [CLAIMS_PARAMS_SUCCESS](state, data) {
    state.claimParams.init = 1
    state.claimParams.initErr = []
    state.claimParams.serviceProviderList = data.serviceProviderList
    state.claimParams.branchList = data.branchList
    state.claimParams.currencyList = []
    // state.claimParams.liabilityList = data.liabilityList
    state.claimParams.bankList = data.bankList
    state.claimParams.busSrcList = data.busSrcList
    // Header Transaction date validation
    if (data.claimTranDateRange) {
      state.claimParams.claimTranDateRange = data.claimTranDateRange
    }
    // payment Transaction date validation
    if (data.paymentTranDateRange) {
      state.claimParams.paymentTranDateRange = data.paymentTranDateRange
    }
    // base currency and rate
    state.claimParams.baseCurr = data.baseCurr
    state.claimParams.baseRate = data.baseRate
    // busCls Permit GST
    if (data.permitGST) {
      state.claimParams.permitGST = data.permitGST
    }
    data.currencyList.map(item => {
      const currency = {
        value: item.value,
        rate: item.secondaryValue,
        label: item.label
      }
      state.claimParams.currencyList.push(currency)
    })
  },
  [CLAIMS_PARAMS_FAIL](state, error) {
    state.claimParams.init = 2
    state.claimParams.initErr = error
    state.claimParams.serviceProviderList = []
  },
  [CLAIMS_PARAMS_RESERVES_SUCCESS](state, data) {
    state.claimParams.init = 1
    state.claimParams.initErr = []
    state.claimParams.reservesList = []
    data.map(item => {
      const reserve = {
        value: item.value,
        resAmtPNE: item.secondaryValue,
        checkSI: item.thirdValue,
        label: item.label
      }
      state.claimParams.reservesList.push(reserve)
    })
  },
  [CLAIMS_PARAMS_RESERVES_FAIL](state, error) {
    state.claimParams.init = 1
    state.claimParams.initErr = error
    state.claimParams.reservesList = []
  },
  [CLM_REN_MSG_INIT_LOADING](state) {
    state.renewalMessage.init = 0
    state.renewalMessage.initErr = []
    state.renewalMessage.menu = {}
  },
  [CLM_REN_MSG_INIT_SUCCESS](state, data) {
    state.renewalMessage.init = 1
    state.renewalMessage.initErr = []
    state.renewalMessage.menu = data.menu
  },
  [CLM_REN_MSG_INIT_FAIL](state, error) {
    state.renewalMessage.init = 2
    state.renewalMessage.initErr = error
    state.renewalMessage.menu = {}
  },
  [CLAIMS_HASRIORRESADJ](state, data) {
    state.clmHasRIOrResAdj.hasRIOrResAdj = data.hasRIOrResAdj
  },
  [CLAIMS_HASRIORRESADJ_LOADING](state) {
    state.clmHasRIOrResAdj.hasRIOrResAdj = false
  }
}

const commitInitClaim = (state, data) => {
  state.claimDetail.commonInfo = { ...data }
}
